<div class="single_page_wrapper d-flex flex-column">
    <div class="logo_header text-center p-2">
        <a href="/" title="Family Central logo"><img src="/assets/images/familycentral-logo.svg" width="155" height="87" alt="Family Central" /></a>
    </div>
    <div class="single_page_body d-flex justify-content-center align-items-center flex-grow-1">
        <div class="single_page_content">
            <p class="text-center mb-3">Family Central is a web and mobile app to organize a family's day-to-day life. Family Central, your go-to resource, gives you and your family peace of mind knowing that all the details and documents are within reach to help you today and in the future.</p>

            <div class="card_wrapper">
                <div class="card_container">
                    <div class="card_header text-center">
                        <p class="fs-5 mb-0">Welcome to the</p>
                        <h2 class="h2">Dodla Family</h2>
                    </div>

                    <div class="form-group submit_btn text-center d-flex flex-column gap-3">
                        <a class="primary_btn w-100" routerLink="/questionnaires">Join your family</a>
                        <button type="button" class="border_btn w-100" data-bs-toggle="modal"
                        data-bs-target="#viewFamilyMembers">View Family Members</button>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>


<!-- Add Family Member Modal -->
<div class="modal fade" id="viewFamilyMembers">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="fc_modal_body">
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    <h3 class="h3">View Family Members</h3>

                    <div class="family_list d-grid gap-2 mt-3">
                        <div class="single_profile card_wrapper">
                            <div class="profile_content card_container text-center">
                                <div class="mb-3">
                                    <img width="20" height="20" alt="profile" src="https://familycentral.com/assets/images/user-icon.svg">
                                </div>
                                <div class="family_name">
                                    <h4 class="mb-0 fs-5">First name</h4>
                                </div>
                            </div>
                        </div>
                        <div class="single_profile card_wrapper">
                            <div class="profile_content card_container text-center">
                                <div class="mb-3">
                                    <img width="20" height="20" alt="profile" src="https://familycentral.com/assets/images/user-icon.svg">
                                </div>
                                <div class="family_name">
                                    <h4 class="mb-0 fs-5">First name</h4>
                                </div>
                            </div>
                        </div>
                        <div class="single_profile card_wrapper">
                            <div class="profile_content card_container text-center">
                                <div class="mb-3">
                                    <img width="20" height="20" alt="profile" src="https://familycentral.com/assets/images/user-icon.svg">
                                </div>
                                <div class="family_name">
                                    <h4 class="mb-0 fs-5">First name</h4>
                                </div>
                            </div>
                        </div>
                        <div class="single_profile card_wrapper">
                            <div class="profile_content card_container text-center">
                                <div class="mb-3">
                                    <img width="20" height="20" alt="profile" src="https://familycentral.com/assets/images/user-icon.svg">
                                </div>
                                <div class="family_name">
                                    <h4 class="mb-0 fs-5">First name</h4>
                                </div>
                            </div>
                        </div>
                        <div class="single_profile card_wrapper">
                            <div class="profile_content card_container text-center">
                                <div class="mb-3">
                                    <img width="20" height="20" alt="profile" src="https://familycentral.com/assets/images/user-icon.svg">
                                </div>
                                <div class="family_name">
                                    <h4 class="mb-0 fs-5">First name</h4>
                                </div>
                            </div>
                        </div>
                        <div class="single_profile card_wrapper">
                            <div class="profile_content card_container text-center">
                                <div class="mb-3">
                                    <img width="20" height="20" alt="profile" src="https://familycentral.com/assets/images/user-icon.svg">
                                </div>
                                <div class="family_name">
                                    <h4 class="mb-0 fs-5">First name</h4>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>